import React from 'react';
import SEO from '@/components/SEO';
import { Separator } from '@/components/ui/separator';
import { useLanguage } from '@/contexts/language/LanguageContext';

const CaseStudies = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen pt-24 pb-16">
      <SEO
        title="Case Studies | Stratodata"
        description="Real results from real retail clients. See how Stratodata helped retailers and ecommerce brands transform their data operations and grow profitability."
        canonical="/case-studies"
      />
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mt-8 mb-4">{t('caseStudiesTitle')}</h1>
          <p className="text-lg text-muted-foreground mb-8">
            {t('caseStudiesSubtitle')}
          </p>
          
          <Separator className="my-8" />
          
          <div className="py-12 text-center">
            <p className="text-xl text-muted-foreground">
              {t('comingSoon')}
            </p>
            <p className="mt-4 text-muted-foreground">
              {t('checkBack')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseStudies;
